<template>
  <div>

    <footer class="grayscale">
      <p>
        <span class="c1" v-if="showPro">云南省司法厅</span>
        <span @click="clearAllCache">技术支持</span>
        <span v-if="technical !== 'hide'">：</span>
        <span v-if="technical !== 'hide'" @click="openModal(1, '')" v-html="technical" />
        <span class="c2" @click="openModal(2, '管理登录')">终端管理</span>
        <span class="c2" @click="openModal(1, '')">售后联系方式</span>
      </p>
    </footer>
    <Dialogs v-model="dialog">
      <template slot="body">
        <form class="form-horizontal" v-if="dialog.type == 2">
          <div class="form-group login-row">
            <label for="inputEmail3" class="col-sm-2 control-label input-label">账号</label>
            <div class="col-sm-10">
              <input type="email" class="form-control login-input" id="inputEmail3" placeholder="账号" v-model="user">
            </div>
          </div>
          <div class="form-group login-row">
            <label for="inputPassword3" class="col-sm-2 control-label input-label">密码</label>
            <div class="col-sm-10">
              <input type="password" class="form-control login-input" id="inputPassword3" placeholder="密码" v-model="password">
            </div>
          </div>
        </form>
        <div class="abut-us-panel" v-if="dialog.type == 1">
          <div class="title" @click="showService">
            联系我们
          </div>
          <div class="company-erweima">
            <img src="https://qiniu.laway.cn/yn/2024/04/22/59f089a4005511efaff4b4055d0b07be.jpg">
            <p>
              关注微信公众号
            </p>
          </div>
          <div class="company-name">
            <h1 @click="handleClickTitle">
              律品汇科技（北京）有限公司
            </h1>
            <h3>
              https://www.lvpin100.com
            </h3>
          </div>
          <div class="company-info-panel">
            <div class="desc">售后电话：18184823508</div>
            <div class="desc">人事合作：HR@LVPIN100.COM</div>
            <div class="desc">商务合作：MD@LVPIN100.COM </div>
            <div class="desc">联系地址：北京市东城区朝阳门北京inn4号楼A218 </div>
            <div class="desc">联系电话： ‭010-58644230（北京）、0871-65165796（云南分部）（工作日9:00-18:00） </div>
          </div>
        </div>
      </template>
      <template slot="foot" v-if="dialog.type == 2">
        <a class="lp-btn large primary login-btns" @click="toInitial()">登录</a>
        <a class="lp-btn large primary" @click="dialog.show = false">取消</a>
      </template>
    </Dialogs>
  </div>
</template>
<script>
import Dialogs from '@/components/Dialog.vue'

export default {
  props: {
    showPro: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Dialogs
  },
  data () {
    return {
      dialog: {
        show: false,
        title: '',
        type: '',
        cancelBtn: '返回'
      },
      user: '',
      password: '',
      toTestPageCount: 0
    }
  },
  computed: {
    technical () {
      const point = this.$point.config && JSON.parse(this.$point.config)
      const config = this.$config.base_config && JSON.parse(this.$config.base_config)
      let title = ''
      try {
        if (point && point.footer) {
          title = point.footer === undefined ? '律品汇科技（北京）有限公司' : point.footer
        } else if (config && config.footer) {
          title = config.footer === undefined ? '律品汇科技（北京）有限公司' : config.footer
        } else if (point && point.footer === '') {
          title = 'hide'
        } else if (config && config.footer === '') {
          title = 'hide'
        } else {
          title = '律品汇科技（北京）有限公司'
        }
        return title
      } catch (error) {
        console.log(error)
        return '律品汇科技（北京）有限公司'
      }
    }
  },
  methods: {
    openModal (type, title) {
      if (this.technical.includes('律品汇科技（北京）有限公司') || title === '管理登录') {
        this.dialog.type = type
        this.dialog.title = title
        this.dialog.show = !this.dialog.show
      }
    },
    clearAllCache () {
      try {
        if (NativeInterface && NativeInterface.clearAllCache) { // eslint-disable-line
          NativeInterface.clearAllCache() // eslint-disable-line
        }
      } catch (error) {
        console.log(error)
      }
    },
    showService () {
      try {
        if (NativeInterface && NativeInterface.showService) { // eslint-disable-line
          NativeInterface.showService() // eslint-disable-line
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleClickTitle () {
      this.toTestPageCount++
      if (this.toTestPageCount > 10) {
        if (confirm('是否进入测试页面?')) {
          this.$router.push('/test_page');
        }
      }
    },
    toInitial () {
      if (this.user !== 'ynpublaw') {
        this.$message.error('账号输入有误，请重新输入');

        return
      } else if (this.password !== 'yn12348') {
        this.$message.error('密码输入有误，请重新输入');

        return
      }
      this.$router.push('/initial')
    },

  }
}
</script>
<style lang="stylus" scoped>
footer p
  text-align center
  font-size 0.14rem
  color #7b79a7
  margin-top 0.35rem
  margin-bottom 0.45rem
  margin 0.1rem 0 0.15rem 0
  .c1
    margin-right 0.2rem
  .c2
    margin-left 0.2rem
.abut-us-panel
  position relative
  width 8rem
  .title
    font-size 0.3rem
    font-weight 600
    padding 0.15rem 0
  .company-erweima
    position absolute
    top 0.1rem
    right 0
    text-align center
    p
      padding 0.1rem 0
      font-size 0.16rem
  .company-name
    height 0.8rem
    display flex
    padding 0.1rem 0
    flex-direction column
    justify-content space-between
    h1
      font-size 0.24rem
    h3
      color #ff6700
  .company-info-panel
    line-height 1.6
    padding 0.2rem 0
</style>
